import { render, staticRenderFns } from "./TopLocations.vue?vue&type=template&id=6665ed5d&scoped=true&"
import script from "./TopLocations.vue?vue&type=script&lang=js&"
export * from "./TopLocations.vue?vue&type=script&lang=js&"
import style0 from "./TopLocations.vue?vue&type=style&index=0&id=6665ed5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6665ed5d",
  null
  
)

export default component.exports